import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { documentOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../../../../common/message-box/message-box.component';
import { UserService } from '../../../../services/user.service';
import { DatePipe } from '@angular/common';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { DateObject, Document_Upload, Document_Upload_File } from '../../../../models/common';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstActivitiesSeminarsSpeakersComponent } from '../ist-activities-seminars-speakers/ist-activities-seminars-speakers.component';
import { GridApi } from 'ag-grid-community';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivitySeminar } from 'src/app/models/um/organization';

@Component({
  selector: 'app-ist-activities-seminars-view-modal',
  templateUrl: './ist-activities-seminars-view-modal.component.html',
  styleUrls: ['./ist-activities-seminars-view-modal.component.scss']
})
export class IstActivitiesSeminarsViewModalComponent implements OnInit {

  startminDate : Date
  endminDate : Date
  @Input() public Content: any;
  myDate = new Date(new Date().getTime() - (24 * 60 * 60 * 1000));
  year = this.myDate.getFullYear();
  moth = this.myDate.getMonth() + 1;
  Day = this.myDate.getDate();
  documaent_attach_list: Document_Upload_File[] = [];
  columnDefs;
  formFields;
  activitiesSeminarsForm: UntypedFormGroup;
  ActivitySessions: UntypedFormGroup;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  files: any[];
  StartDate: Date
  EndDate: Date
  uploadInput: EventEmitter<any>;
  humanizeBytes: Function;
  dragOver: boolean;
  typeOptions: any[];
  subtypeOptions: any[];
  AllsubtypeOptions: any[];
  disabledDates:Date[] = [];
  documentOptions = documentOptionsConstant;
  SeminosList: any = [];
  ApplicationID: any;
  Allfiles = [];
  userType: string = "";
  FilesList = [];
  ScreenFilesList = [];
  gridApi: GridApi;
  selectedRow;
  RequiredSettings = true;
  rowData;
  loadGrid = false;
  gridOptions;
  frameworkComponents;
  operations: any[] = [];
  public activeSpeaker: any = "";
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  TempOperations: { name: string; id: string; }[];
  context: any;
  Attachments: any[] = [];
  activityseminar:ActivitySeminar;
  appstatus: boolean;
  staticformFields: any;

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    public modelRef: NgbActiveModal,
    private modalService: NgbModal,
    private appFunctions: AppFunctionsService,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public datepipe: DatePipe,
    public commonService: CommonService

  ) {
    this.files = [];
    this.Allfiles = [];
    this.uploadInput = new EventEmitter<any>();
  }

  ngOnInit() {
    this.startminDate =  new Date() ; this.startminDate.setHours(0,0,0,0); 
    this.endminDate =  new Date() ; this.endminDate.setHours(0,0,0,0); ; 
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.rowData = [];
    this.appstatus= this.commonService.getIstStatus();
    this.userType = this.userService.getUserType();
    this.getStaticFiledsData('SCR-010');
    this.files = [];

    this.activitiesSeminarsForm = new UntypedFormGroup({
          ID: new UntypedFormControl(""),
          APPLICATION_ID: new UntypedFormControl(""),
          TYPE: new UntypedFormControl(""),
          SUB_TYPE: new UntypedFormControl(""),
          START_DATE: new UntypedFormControl(null),
          END_DATE: new UntypedFormControl(null),
          TITLE: new UntypedFormControl(""),
          AGENDA: new UntypedFormControl(""),
          OVERVIEW: new UntypedFormControl(""),
          NOTES: new UntypedFormControl(""),
          STATUS: new UntypedFormControl(0),
          START_DATEO: new UntypedFormControl(null),
          END_DATEO: new UntypedFormControl(null),
    });
    this.ActivitySessions = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      FIST_NAME: new UntypedFormControl(""),
      LAST_NAME: new UntypedFormControl(""),
      QUALIFICATION: new UntypedFormControl(""),
      OCCUPATION: new UntypedFormControl(""),
      FileNameExt: new UntypedFormControl(""),
      FILES: new UntypedFormControl(null),
      Attachments: new UntypedFormControl("")
    });

    this.TempOperations = [];
    this.GetMasterDropData();
    if (this.Content.heading == 'Add' || this.Content.heading == 'Edit') {
      this.TempOperations.push(
        {
          "name": "Edit",
          "id": "Edit"
        },
        {
          "name": "Delete",
          "id": "Delete"
        }
      );
    }

    if (this.Content.heading == 'View') {
      this.TempOperations.push(
        {
          "name": "View",
          "id": "view"
        }
      );
    }

    if (this.Content.heading === 'Edit') { // Edit mode
      this.getRecordFprEdit();
     this.activityseminar = new ActivitySeminar();

    } else if (this.Content.heading === 'View') { //View mode 
      this.getRecordFprEdit();
      this.activitiesSeminarsForm.disable();
    }

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,
      IsScreenGrid: true,
      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }

    this.columnDefs = [
      {
        "headerName": "Activity Session Title",
        "field": "TITLE"
      },
      {
        "headerName": "Speaker",
        "field": "FIST_NAME"
      },
      {
        headerName: "",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        width: 50,
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }
    ];

    this.context = { id: this.Content.content.id, componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };

    this.operations = this.TempOperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }
   // this.disable();
  }
  
  GetMasterDropData() {
    this.summaryService.getScreenDataForEdit("api/ISTActivitiesseminars/GetMasterDropData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.Content.content.id).subscribe(result => {
      this.typeOptions = result["MasterData1"];
      this.typeOptions = [{ label: "Select", value: null, checked: true }].concat(this.typeOptions);

      this.AllsubtypeOptions = result["MasterData2"];
      this.AllsubtypeOptions = [{ label: "Select", value: null, checked: true }].concat(this.AllsubtypeOptions);

    });
  }

  disable(){
    if(this.activitiesSeminarsForm.controls['TYPE'].value == null || this.activitiesSeminarsForm.controls['TYPE'].value == "" || this.activitiesSeminarsForm.controls['TYPE'].value == undefined){
      this.activitiesSeminarsForm.controls['SUB_TYPE'].disable();
    } else{
      if(this.Content.heading != 'View'){
        this.activitiesSeminarsForm.controls['SUB_TYPE'].enable();
      }
    }
  }

  CategoryChange(data1) {
    this.subtypeOptions = [];
    var data = this.AllsubtypeOptions?.filter(x => x.Parentvalue == data1);
    this.subtypeOptions = [{ label: "Select", value: null, checked: true }].concat(data);
    this.disable();
  }
  getRecordFprEdit() {
    let today = new Date(); today.setHours(0,0,0,0);
    this.summaryService.getScreenDataForEdit("api/ISTActivitiesseminars/Edit?RecordID=" + this.Content.content.id).subscribe(result => {

      if (result != null) {

        if (result["START_DATE"] != null && result["START_DATE"] != "" && result["START_DATE"] != undefined) {
        debugger
          this.StartDate = this.commonService.getdisplayedDate(result["START_DATE"]);
          result["START_DATE"] = this.StartDate;
          this.activitiesSeminarsForm.controls["START_DATE"].setValue( result["START_DATE"]);
              let date = new Date(this.StartDate);
              setTimeout(()=>{
                while (date < today) {
                  this.disabledDates.push(new Date(date));
                  date.setDate(date.getDate() + 1);}
              },1000);
              if( this.StartDate < today){
                this.startminDate = this.StartDate
          }

        }
        if (result["END_DATE"] != null && result["END_DATE"] != "" && result["END_DATE"] != undefined) {
         
          this.EndDate = this.commonService.getdisplayedDate(result["END_DATE"]);
          result["END_DATE"] = this.EndDate;
          this.activitiesSeminarsForm.controls["END_DATE"].setValue( result["END_DATE"]);
             let date = new Date(this.EndDate);
              setTimeout(()=>{
                while (date < today) {
                  this.disabledDates.push(new Date(date));
                  date.setDate(date.getDate() + 1);}
              },1000);
               if( this.EndDate < today){
                   this.endminDate = this.EndDate
          }
        }  
        setTimeout(() => {
          this.activitiesSeminarsForm.patchValue({
            ID: result["ID"],
            APPLICATION_ID: result["APPLICATION_ID"],
            TYPE: result["TYPE"],
            SUB_TYPE: result["SUB_TYPE"],
            START_DATE: result["START_DATE"],
            END_DATE: result["END_DATE"],
            TITLE: result["TITLE"],
            AGENDA: result["AGENDA"],
            NOTES: result["NOTES"],
            OVERVIEW: result["OVERVIEW"]
          });
        }, 100);

        result["ChildList"].forEach(x => {
          this.GetSessionDetails(x);
          this.loadGrid = false;

          this.rowData.push(this.ActivitySessions.value);
          setTimeout(() => {
            this.loadGrid = true;
            document.body.click();
          }, 300);
        });

        this.CategoryChange(this.activitiesSeminarsForm.controls["TYPE"].value);

        this.extendedForm.rowid = result["ID"];
        this.extendedForm.getResponse();

      }
    });
  }


  private getForm():ActivitySeminar
  {
    const formModel = this.activitiesSeminarsForm.getRawValue();
    let obj = new ActivitySeminar();
    obj = {
     ID: formModel.ID ,
     APPLICATION_ID : formModel.APPLICATION_ID || '',
     TYPE : formModel.TYPE || '',
     SUB_TYPE:formModel.SUB_TYPE || '',
     START_DATE:formModel.START_DATE || null,
     END_DATE :formModel.END_DATE || null,
     TITLE :formModel.TITLE|| '',
     AGENDA:formModel.AGENDA|| '',
     OVERVIEW:formModel.OVERVIEW || '',
     NOTES:formModel.NOTES|| '',
     STATUS:formModel.STATUS || 0,
     START_DATEO :formModel.START_DATEO || null,
     END_DATEO : formModel.END_DATEO || null
    };
    if(this.Content.heading != "Add")
    {
      this.activityseminar.ID = obj.ID;
      this.activityseminar.APPLICATION_ID = obj.APPLICATION_ID;
      this.activityseminar.TYPE = obj.TYPE;
      this.activityseminar.SUB_TYPE = obj.SUB_TYPE;
      this.activityseminar.START_DATE = obj.START_DATE;
      this.activityseminar.END_DATE = obj.END_DATE;
      this.activityseminar.TITLE = obj.TITLE;
      this.activityseminar.AGENDA = obj.AGENDA;
      this.activityseminar.OVERVIEW = obj.OVERVIEW;
      this.activityseminar.NOTES = obj.NOTES;
      this.activityseminar.STATUS=obj.STATUS;
      const sdate = this.GetStartDate();
      this.activityseminar.START_DATEO = sdate;
        const edate = this.GetEndDate();
      this.activityseminar.END_DATEO = edate;
      return this.activityseminar;
    }
    else 
    {
      const sdate = this.GetStartDate();
      const edate = this.GetEndDate();
      obj.START_DATEO = sdate;
      obj.END_DATEO = edate;
      return obj;
    }
  }

  SaveActivitySeminors() {

    if (this.validateControls()) {
      var formData = new FormData();
      let fileList: any[] = [];
      for (let j = 0; j < this.rowData.length; j++) {
        for (let i = 0; i < this.rowData[j].FILES.length; i++) {
          formData.append(this.rowData[j].FILES[i].ID, this.rowData[j].FILES[i].File);
          fileList.push(this.rowData[j].FILES[i]);
          this.rowData[j].FILES[i].File = null;
        }
      }


     // var formData1 = this.activitiesSeminarsForm.value;
     var formData1 = this.getForm();
     formData1.TITLE=formData1.TITLE==null?null:formData1.TITLE==undefined?undefined:formData1.TITLE.trim();
     formData1.AGENDA =formData1.AGENDA==null?null:formData1.AGENDA==undefined?undefined:formData1.AGENDA.trim();
     formData1.NOTES=formData1.NOTES==null?null:formData1.NOTES==undefined?undefined:formData1.NOTES.trim();
      formData1["APPLICATION_ID"] = this.ApplicationID;
      if (formData1["START_DATE"] != null) {
        const ldate = new Date(formData1["START_DATE"]);

        formData1["STR_START_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

        formData1["START_DATE"] = new Date(formData1["START_DATE"]);
      }
      if (formData1["END_DATE"] != null) {
        const ldate = new Date(formData1["END_DATE"]);
        formData1["STR_END_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        formData1["END_DATE"] = new Date(formData1["END_DATE"]);
      }
      formData1["IST_SEMINAR_SPEAKER"] = this.rowData;
      formData1["Attachments"] = fileList;

      formData.append("ScreenData", JSON.stringify(formData1));

      if (this.Content.heading == "Add") {
        this.summaryService.FilesInsert("api/ISTActivitiesseminars/Insert", formData).subscribe(result => {
          this.activitiesSeminarsForm.controls["ID"].setValue(result.TransactionID);
          if (result.Status == 0) {
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.Status == 0)
               {
                this.commonService.SuccessBanner('Activity and Seminar ' +"'" + formData1['TITLE'] + "'" + ' Added/Submitted successfully');
                this.modalRef.close();
              }
              else
              {
                this.commonService.ValidationBanner(result1.Message);
              }
            });
          }
          else
          {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.FilesInsert("api/ISTActivitiesseminars/Update", formData).subscribe(result => {
          if (result.Status == 0 || result.ErrorCode == "NOCHANGES") {
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS") {
                if (result.Status == 0 )
                {
                  this.commonService.SuccessBanner('Activity and Seminar ' + "'" + formData1['TITLE'] + "'" + ' updated successfully');
                  this.modelRef.close();
                }
                else{
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else{
                if (result1.ErrorCode == "NOCONTROLS" && result.ErrorCode == "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else{
                  this.commonService.SuccessBanner('Activity and Seminar ' + "'" + formData1['TITLE'] + "'" + ' updated successfully');
                   this.modalRef.close(formData);
                }
              }
            });
          }
          else{
            this.commonService.ValidationBanner(result.Message);
          }

          // if (result.Status == 0) {
          //   this.activitiesSeminarsForm.controls["ID"].setValue(result.TransactionID);
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     this.commonService.SuccessBanner('Activity and Seminar ' + formData1['TITLE'] + ' updated successfully');
          //     this.modelRef.close();
              
          //   });
          // } else {
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     if (result1.ErrorCode == "NOCONTROLS" && result.ErrorCode == "NOCHANGES") {
          //       this.commonService.ValidationBanner(result.Message);
          //     }
          //     else {
          //       if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
          //         this.commonService.ValidationBanner(result.Message);
          //       }
          //       else {
          //         this.commonService.SuccessBanner('Activity and Seminar ' + formData1['TITLE'] + ' updated successfully');
          //        // this.action.next(formData);
          //         this.modalRef.close(formData);
          //       }
          //     }
          //   });
          // }

        });
      }
    }
  }

  RemoveSpeacher(id) {

    var filterData = this.SeminosList.filter(item => {
      return item.ID != id;
    });
    this.SeminosList = [];
    this.SeminosList = filterData;
  }

  public p8(s: boolean): string {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }
  uploadchange(event): void {
    if (this.documaent_attach_list == undefined || this.documaent_attach_list == null)
      this.documaent_attach_list = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      uploadFile.ID = this.CreateGuid();
      uploadFile.DOCUMENT_NAME = event.target.files[i].name;
      uploadFile.File = event.target.files[i];
      uploadFile.Status = "Add";
      this.ActivitySessions.controls["FileNameExt"].setValue(uploadFile.DOCUMENT_NAME);
      this.documaent_attach_list.push(uploadFile);
    }
  }
  DeleteUpload() {
    let code = this.ActivitySessions.controls["FileNameExt"].value;
    this.documaent_attach_list = this.documaent_attach_list.filter(function (sec) {
      return sec.DOCUMENT_NAME != code;
    }, code);
    this.ActivitySessions.controls["FileNameExt"].setValue("");
  }

  DeleteSavedUpload(item): void {
    this.summaryService.DeleteRecord("api/ISTFileAttachments/DeleteFile?FileID=" + item).subscribe(result => {
      let code = item;
      this.FilesList = this.FilesList.filter(function (sec) {
        return sec.ID != code;
      }, code);
    });
  }

  DownloadFile(ID) {
    var fileID = ID;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  SaveSession() {

    if (this.SessionvalidateControls()) {
      var childData = this.ActivitySessions.value;
      if (childData.ID == "") {
        childData.ID = (this.SeminosList.length) + 1 + "";
        this.SeminosList.push(childData);
        this.files = [];
      }
      else {
        this.SeminosList.forEach(x => {
          if (x.ID == childData.ID) {
            x.TITLE = childData["TITLE"];
            x.FIST_NAME = childData["FIST_NAME"];
            x.LAST_NAME = childData["LAST_NAME"];
            x.QUALIFICATION = childData["QUALIFICATION"];
            x.OCCUPATION = childData["OCCUPATION"];
            x.FILES = childData["FILES"];
          }
        });
      }
      this.ActivitySessions.controls["ID"].setValue("");
      this.ActivitySessions.controls["FileNameExt"].setValue("");
      this.ActivitySessions.controls["TITLE"].setValue("");
      this.ActivitySessions.controls["FIST_NAME"].setValue("");
      this.ActivitySessions.controls["LAST_NAME"].setValue("");
      this.ActivitySessions.controls["QUALIFICATION"].setValue("");
      this.ActivitySessions.controls["OCCUPATION"].setValue("");
      this.ActivitySessions.controls["FILES"].setValue(null);
      this.FilesList = [];
    }
  }

  SessionvalidateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.ActivitySessions.value;
    if (formData.TITLE === null || formData.TITLE === "" || formData.TITLE === undefined) {
      $("#SeminorTITLE").addClass("ng-touched ng-invalid validate-error");
      $("#SeminorTITLE").removeClass("ng-untouched ng-valid");
      message += "Please enter  Activity Session Title<br/>";
      isValid = false;
    } else {
      $("#SeminorTITLE").addClass("ng-untouched ng-valid");
      $("#SeminorTITLE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.FIST_NAME === null || formData.FIST_NAME === "") {
      $("#FIST_NAME").addClass("ng-touched ng-invalid validate-error");
      $("#FIST_NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter First Name<br/>";
      isValid = false;
    } else {
      $("#FIST_NAME").addClass("ng-untouched ng-valid");
      $("#FIST_NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.OCCUPATION === null || formData.OCCUPATION === "") {
      $("#OCCUPATION").addClass("ng-touched ng-invalid validate-error");
      $("#OCCUPATION").removeClass("ng-untouched ng-valid");
      message += "Please enter Occupation<br/>";
      isValid = false;
    } else {
      $("#OCCUPATION").addClass("ng-untouched ng-valid");
      $("#OCCUPATION").removeClass("ng-touched ng-invalid validate-error");
    }
    if (formData.QUALIFICATION === null || formData.QUALIFICATION === "") {
      $("#QUALIFICATION").addClass("ng-touched ng-invalid validate-error");
      $("#QUALIFICATION").removeClass("ng-untouched ng-valid");
      message += "Please enter Qualification<br/>";
      isValid = false;
    } else {
      $("#QUALIFICATION").addClass("ng-untouched ng-valid");
      $("#QUALIFICATION").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }
  GetSessionDetails(data) {

    this.files = [];

    // this.FilesList = this.rowData.filter((xyz) => {
    //   return (xyz.FileID == data["ID"])
    // });
      ;
    this.ActivitySessions.controls["ID"].setValue(data["ID"]);
    if (data["FileNameExt"] != null && data["FileNameExt"] != undefined && data["FileNameExt"] != "") {
      this.ActivitySessions.controls["FileNameExt"].setValue(data["FileNameExt"]);
    }
    else {
      this.ActivitySessions.controls["FileNameExt"].setValue("");
    }
    this.ActivitySessions.controls["TITLE"].setValue(data["TITLE"]);
    this.ActivitySessions.controls["FIST_NAME"].setValue(data["FIST_NAME"]);
    this.ActivitySessions.controls["LAST_NAME"].setValue(data["LAST_NAME"]);
    this.ActivitySessions.controls["QUALIFICATION"].setValue(data["QUALIFICATION"]);
    this.ActivitySessions.controls["OCCUPATION"].setValue(data["OCCUPATION"]);
    this.ActivitySessions.controls["FILES"].setValue(data["FILES"]);
    this.files = data["FileNameExt"];
    this.activeSpeaker = data["ID"];
  }
  showFiles() {
    let files = '';
    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    return files;
  }

  startUpload(): void {
    const event: any = {
      type: 'uploadAll',
      url: 'your-path-to-backend-endpoint',
      method: 'POST',
      data: { foo: 'bar' },
    };
    this.files = [];
    this.uploadInput.emit(event);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }
  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.activitiesSeminarsForm.value;

    if(this.staticformFields?.TYPE.IS_MANDATORY && this.staticformFields?.TYPE.IS_Display){
      if (formData.TYPE === null || formData.TYPE === "") {
        $("#TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.TYPE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#TYPE").addClass("ng-untouched ng-valid");
        $("#TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.TYPE.IS_Display && this.staticformFields?.SUB_TYPE.IS_MANDATORY && this.staticformFields?.SUB_TYPE.IS_Display){
      if (formData.SUB_TYPE === null || formData.SUB_TYPE === "") {
        $("#SUB_TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#SUB_TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.SUB_TYPE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#SUB_TYPE").addClass("ng-untouched ng-valid");
        $("#SUB_TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.START_DATE.IS_MANDATORY && this.staticformFields?.START_DATE.IS_Display){
      if (formData.START_DATE === null || formData.START_DATE === "") {
        $("#START_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#START_DATE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.START_DATE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#START_DATE").addClass("ng-untouched ng-valid");
        $("#START_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.END_DATE.IS_MANDATORY && this.staticformFields?.END_DATE.IS_Display){
      if (formData.END_DATE === null || formData.END_DATE === "") {
        $("#END_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#END_DATE").removeClass("ng-untouched ng-valid");
        message +=`Please select ${this.staticformFields?.END_DATE.LABEL_NAME} <br/>`;
        isValid = false;
      } else {
        $("#END_DATE").addClass("ng-untouched ng-valid");
        $("#END_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.TITLE.IS_MANDATORY && this.staticformFields?.TITLE.IS_Display){
      if (formData.TITLE === null || formData.TITLE === ""||formData.TITLE=== undefined) {
        $("#TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TITLE.LABEL_NAME} <br/>`;
        isValid = false;
      }else if(formData.TITLE != null && formData.TITLE != undefined && formData.TITLE.trim()==""){
        $("#TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TITLE.LABEL_NAME} <br/>`;
        isValid = false;
      } 
      else {
        $("#TITLE").addClass("ng-untouched ng-valid");
        $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.AGENDA.IS_MANDATORY && this.staticformFields?.AGENDA.IS_Display){
      if (formData.AGENDA === null || formData.AGENDA === ""||formData.AGENDA=== undefined) {
        $("#AGENDA").addClass("ng-touched ng-invalid validate-error");
        $("#AGENDA").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.AGENDA.LABEL_NAME} <br/>`;
        isValid = false;
      } else if(formData.AGENDA != null && formData.AGENDA != undefined && formData.AGENDA.trim()==""){
        $("#AGENDA").addClass("ng-touched ng-invalid validate-error");
        $("#AGENDA").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.AGENDA.LABEL_NAME} <br/>`;
        isValid = false;
      } 
      else {
        $("#AGENDA").addClass("ng-untouched ng-valid");
        $("#AGENDA").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if(this.staticformFields?.NOTES.IS_MANDATORY && this.staticformFields?.NOTES.IS_Display){
      if (formData.NOTES === null || formData.NOTES === ""||formData.NOTES=== undefined ) {
        $("#NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NOTES.LABEL_NAME} <br/>`;
        isValid = false;
      }else if(formData.NOTES != null && formData.NOTES != undefined && formData.NOTES.trim()==""){
        $("#NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NOTES.LABEL_NAME} <br/>`;
        isValid = false;
      }
       else {
        $("#NOTES").addClass("ng-untouched ng-valid");
        $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }
    

    if (formData.OCCUPATION === null || formData.OCCUPATION === "") {
      $("#OCCUPATION").addClass("ng-touched ng-invalid validate-error");
      $("#OCCUPATION").removeClass("ng-untouched ng-valid");
      message += "Please enter Occupation<br/>";
      isValid = false;
    } else {
      $("#OCCUPATION").addClass("ng-untouched ng-valid");
      $("#OCCUPATION").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.QUALIFICATION === null || formData.QUALIFICATION === "") {
      $("#QUALIFICATION").addClass("ng-touched ng-invalid validate-error");
      $("#QUALIFICATION").removeClass("ng-untouched ng-valid");
      message += "Please enter Qualification<br/>";
      isValid = false;
    } else {
      $("#QUALIFICATION").addClass("ng-untouched ng-valid");
      $("#QUALIFICATION").removeClass("ng-touched ng-invalid validate-error");
    }
    var StartDate = formData.START_DATE;
    var EndDate = formData.END_DATE;
    var eDate = new Date(EndDate);
    var sDate = new Date(StartDate);
    if (StartDate != '' && StartDate != '' && sDate > eDate) {
      message = message + "Start Date should not greater than the End Date</br>";
      isValid = false;
    }
    // if (this.rowData != null && this.rowData.length == 0) {
    //   message = message + "Please enter atleast one Speaker</br>";
    //   isValid = false;
    // }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      message = message + ExtenMsgs;
      isValid = false;
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);
    // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validation Message(s)', content: { heading: '', description: message } } });
    return isValid;
  }

  onUploadOutput(output: any | any): void {

    if (output.type === 'allAddedToQueue') {
    } else if (output.type === 'addedToQueue') {
      if (this.files == undefined || this.files == null) {
        this.files = [];
      }
      this.files.push(output.file); // add file to array when added
    } else if (output.type === 'uploading') {
      // update current data in files array for uploading file
      const index = this.files.findIndex(file => file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      // remove file from array when removed
      this.files = this.files.filter((file: any) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
    } else if (output.type === 'drop') {
      this.dragOver = false;
    }
    // this.showFiles();
  }


  //SubmitRecord() {
  //  if (this.validateControls() && this.extendedForm.validateControls()) {
  //    var formData = new FormData();
  //    for (let i = 0; i < this.documaent_attach_list.length; i++) {
  //      formData.append(this.documaent_attach_list[i].DOCUMENT_NAME, this.documaent_attach_list[i].File);
  //      this.documaent_attach_list[i].File = null;
  //    }

  //    var formData1 = this.activitiesSeminarsForm.value;
  //    formData1["APPLICATION_ID"] = this.ApplicationID;
  //    if (formData1["START_DATE"] != null && formData1["START_DATE"] != "") {
  //      formData1["START_DATE"] = new Date(formData1["START_DATE"]);
  //      const ldate = new Date(formData1["START_DATE"]);
  //      formData1["STR_START_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();

  //    }
  //    if (formData1["END_DATE"] != null && formData1["END_DATE"] != "") {
  //      formData1["END_DATE"] = new Date(formData1["END_DATE"]);
  //      const ldate1 = new Date(formData1["END_DATE"]);
  //      formData1["STR_END_DATE"] = ldate1.getFullYear() + "-" + (ldate1.getMonth() + 1) + "-" + ldate1.getDate();

  //    }
  //    formData1["IST_SEMINAR_SPEAKER"] = this.SeminosList;
  //    formData.append("ScreenData", JSON.stringify(formData1));
  //      this.summaryService.FilesInsert("api/ISTActivitiesseminars/Update", formData).subscribe(result => {
  //        this.extendedForm.saveControls(result.TransactionCode).subscribe(result1 => {
  //          this.summaryService.UpdateStatus("api/ISTActivitiesseminars/UpdateStatus?RecordID=" + this.content.id).subscribe(result => {
  //            this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Data has been inserted successfully.' } } });
  //            
  //            this.modalRef.hide();
  //          });
  //        });
  //      });
  //  }
  //}


  SubmitRecord() {

    if (this.validateControls()) {
      var formData = new FormData();
      let fileList: any[] = [];
      let ActivitySeminar = this.activitiesSeminarsForm.controls["TITLE"].value;
      for (let j = 0; j < this.rowData.length; j++) {
        for (let i = 0; i < this.rowData[j].FILES.length; i++) {
          formData.append(this.rowData[j].FILES[i].ID, this.rowData[j].FILES[i].File);
          fileList.push(this.rowData[j].FILES[i]);
          this.rowData[j].FILES[i].File = null;
        }
      }

      // var formData1 = this.activitiesSeminarsForm.value;
      var formData1 = this.getForm();
      formData1["APPLICATION_ID"] = this.ApplicationID;
      if (formData1["START_DATE"] != null) {
        const ldate = new Date(formData1["START_DATE"]);
        formData1["STR_START_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        formData1["START_DATE"] = new Date(formData1["START_DATE"]);
      }
      if (formData1["END_DATE"] != null) {
        const ldate = new Date(formData1["END_DATE"]);
        formData1["STR_END_DATE"] = ldate.getFullYear() + "-" + (ldate.getMonth() + 1) + "-" + ldate.getDate();
        formData1["END_DATE"] = new Date(formData1["END_DATE"]);
      }

      formData1["STATUS"] = 2;
      formData1["IST_SEMINAR_SPEAKER"] = this.rowData;
      formData1["Attachments"] = fileList;

      formData.append("ScreenData", JSON.stringify(formData1));

      if (this.Content.heading == "Add") {
        this.summaryService.FilesInsert("api/ISTActivitiesseminars/Insert", formData).subscribe(result => {
          this.activitiesSeminarsForm.controls["ID"].setValue(result.TransactionID);
          if (result.Status == 0) {
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.Status == 0) {
                this.commonService.SuccessBanner("Activity and Seminar '" + ActivitySeminar + "' Added/Submitted successfully");
                this.modalRef.close();
              }
              else{
                this.commonService.ValidationBanner(result1.Message);
              }
            });
          }
          else{
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.FilesInsert("api/ISTActivitiesseminars/Update", formData).subscribe(result => {
          this.activitiesSeminarsForm.controls["ID"].setValue(result.TransactionID);
          if (result.Status == 0 || result.ErrorCode == "NOCHANGES")
          {
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS")
               {
                if (result.Status == 0)
                {
                  this.commonService.SuccessBanner("Activity and Seminar '" + ActivitySeminar + "' submitted successfully");
                  this.modalRef.close();
                }
                else{
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else
              {
                if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner("Activity and Seminar '" + ActivitySeminar + "' submitted successfully");
                  this.modalRef.close(formData);
                }
              }
            });
          }
          else{
            this.commonService.ValidationBanner(result.Message);
          }


          // if (result.Status == 0) {
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     this.commonService.SuccessBanner("Activity and Seminar " + ActivitySeminar + " submitted successfully");
              
          //     this.modalRef.close();
          //   });
          // } else {
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     if (result1.ErrorCode == "NOCONTROLS" && result.ErrorCode == "NOCHANGES") {
          //       this.commonService.ValidationBanner(result.Message);
          //     }
          //     else {
          //       if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
          //         this.commonService.ValidationBanner(result.Message);
          //       }
          //       else {
          //         this.commonService.SuccessBanner("Activity and Seminar " + ActivitySeminar + " submitted successfully");
          //         //this.action.next(formData);
          //         this.modalRef.close(formData);
          //       }
          //     }
          //   });
          // }



        });
      }
    }
  }


  onRowDoubleClicked(event) {

  }

  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onOperationClick(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Full_Start_Date: DateObject;
  Full_End_Date: DateObject;

  startDateSelect(event) {
    this.isStartDateModified = true
    this.Full_Start_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isStartDateModified
    }
  }

  endDateSelect(event) {
    this.isEndDateModified = true;
    this.Full_End_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: true,
      HasValue: true,
      IsDateModified: this.isEndDateModified
    }
  }

  GetStartDate(): DateObject {
    //let lDate = this.milestoneForm.controls['STUDY_START_DATE'].value;
    var formModel = this.activitiesSeminarsForm.getRawValue();
    const lDate = new Date(formModel.START_DATE);
    //let lDate = new Date(this.milestoneForm['STUDY_START_DATE']) 
    if ((this.CompareDates(this.StartDate, lDate) || this.Full_Start_Date == null || this.Full_Start_Date == undefined) && formModel.START_DATE != null)  {
      this.Full_Start_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 0,
        Minutes: 0,
        Seconds: 0,
        IsEndDate: false,
        HasValue: true,
        IsDateModified: false
      }
    }
      else
      {
        this.Full_Start_Date = {
          Day: lDate.getDate(),
          Month: lDate.getMonth() + 1,
          Year: lDate.getFullYear(),
          Hours: 0,
          Minutes: 0,
          Seconds: 0,
          IsEndDate: false,
          HasValue: true,
          IsDateModified: true
        }
      }
    
    return this.Full_Start_Date
  }

  GetEndDate(): DateObject {
    const formModel = this.activitiesSeminarsForm.getRawValue();
    const lDate = new Date(formModel.END_DATE);
    if ((this.CompareDates(this.EndDate, lDate) || this.Full_End_Date == null || this.Full_End_Date == undefined) && formModel.END_DATE != null)
      this.Full_End_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: false
      }
      else{
        this.Full_End_Date = {
          Day: lDate.getDate(),
          Month: lDate.getMonth() + 1,
          Year: lDate.getFullYear(),
          Hours: 23,
          Minutes: 59,
          Seconds: 59,
          IsEndDate: true,
          HasValue: true,
          IsDateModified: true
        }
      }
    return this.Full_End_Date;
  }

  CompareDates(olddate: any, newDate: any): boolean {
    if (olddate != '' && olddate != undefined && olddate != null) {

      let oDt = olddate.getDate().toString() + olddate.getMonth().toString() + olddate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt) { return true }
      else { return false }
    }
    else
      return false
  }

  add() {
    let modalRef = this.modalService.open(IstActivitiesSeminarsSpeakersComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this.loadGrid = false;
      this.rowData.push(result);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
    });
  }

  Edit() {

    let modelRef = this['self'].modalService.open(IstActivitiesSeminarsSpeakersComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content= {
      heading: "Edit",
      content: {
        id: this['self'].selectedRow['ID'], rowData: this['self'].selectedRow,
        ApplicationID: this.ApplicationID, docList: this['self'].selectedRow['FILES']
      }
    }
    modelRef.result.then(result => {
      this["self"].loadGrid = false;
      let value = this['self'].rowData.findIndex(x => x.ID == result.ID);
      this['self'].rowData[value].FILES=[];
      if (value != -1) {
        if (result.FILES.length > 0) {
          result.FILES.forEach((element: any) => {
            this['self'].rowData[value].FILES.push(element);
          });
        }

        this['self'].rowData[value].FIST_NAME = result.FIST_NAME;
        this['self'].rowData[value].FileId = result.FileId;
        this['self'].rowData[value].FileNameExt = result.FileNameExt;
        this['self'].rowData[value].ID = result.ID;
        this['self'].rowData[value].LAST_NAME = result.LAST_NAME;
        this['self'].rowData[value].OCCUPATION = result.OCCUPATION;
        this['self'].rowData[value].QUALIFICATION = result.QUALIFICATION;
        this['self'].rowData[value].TITLE = result.TITLE;

      }
      setTimeout(() => {
        this["self"].loadGrid = true;
        document.body.click();
      }, 300);
    });
  }

  Delete(summaryService, toastrService) {
   
    let id = this['self'].selectedRow['ID'];
    this['self'].commonService.CheckIsFileIsRefereancedInReviw(id).subscribe((x)=>{
      if(x["Status"]==2 && x["Data"]==false)
      {
        this.commonService.ValidationBanner(x["Message"]);
      }
      else{
        let name = this['self'].selectedRow['FIST_NAME'] + " " + (this['self'].selectedRow['LAST_NAME'] == null ? " " : this['self'].selectedRow['LAST_NAME']);
        let modalRef  = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false });
        modalRef.componentInstance.Content= { heading: 'Delete Speaker', custommessage: 'Are you sure you want to delete the speaker   ' + name + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };
    
        modalRef.result.then(result => {
          if (result == "okclick") {
            this["self"].loadGrid = false;
            let val = this['self'].rowData.findIndex(x => x.ID == this['self'].selectedRow['ID']);
            if (val != -1) {
              this['self'].rowData.splice(val, 1);
            }
            setTimeout(() => {
              this["self"].loadGrid = true;
              //document.body.click();
            }, 300);
          }
        })
      }
    });
   

  }

  view() {

    let modalRef = this['self'].modalService.open(IstActivitiesSeminarsSpeakersComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animanimationated: true,
    });
      modalRef.componentInstance.Content= {
        heading: "View",
        content: {
          id: this['self'].selectedRow['ID'], rowData: this['self'].selectedRow,
          ApplicationID: this.ApplicationID, docList: this['self'].selectedRow['FILES']
        }

      }
    
  }

  close() {
    this.modelRef.dismiss();
  }

  getStaticFiledsData(screenCode:string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }
}
